// import React from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import ss1 from '../images/ss1.webp';
// import { TrustStrip, StepFlow, MiniFAQ, CredibilityGrid } from '../Components/shared/LandingBlocks';

// const trustItems = [
//   'Work with real creators',
//   'Keep ALL of your earnings',
//   'No bidding wars or hidden visibility rules',
// ];

// const howItWorks = [
//   {
//     title: 'Create Profile',
//     desc: 'Set up a short creator-facing profile that highlights your editing strengths.',
//   },
//   {
//     title: 'Get Discovered',
//     desc: 'Appear in creator searches and match with requests that fit your editing style AND category.',
//   },
//   {
//     title: 'Work With Creators',
//     desc: 'Accept jobs, collaborate directly, and keep ALL revenue unlike marketplace alternatives like Fiverr.',
//   },
// ];

// const credibilityItems = [
//   {
//     title: 'Live Creator Requests',
//     description: 'Connect to real content creators actively looking for editors today.',
//   },
//   {
//     title: 'Verified Profiles',
//     description: 'Build a stronger profile with portfolio examples and creator verification.',
//   },
//   {
//     title: 'NO Middleman Cuts',
//     description: 'Keep 100% of money from every job and avoid fee surprises.',
//   },
// ];

// const faqs = [
//   {
//     id: 1,
//     question: 'How do payouts work?',
//     answer: 'You set your rate, creators pay it, and you keep more because we get our cut from the creator, NOT you. When you have a big enough payout, connect your Stripe account and withdraw to your bank account via ACH transfer or another option.',
//   },
//   {
//     id: 2,
//     question: 'Can creators find my profile?',
//     answer: 'Yes, your profile appears to creators browsing for Twitch and YouTube editors with your skills within your specific category.',
//   },
//   {
//     id: 3,
//     question: 'Do I communicate directly with clients?',
//     answer: 'Every conversation happens directly with the creator, so feedback stays fast and clear. If you see a creator with a portfolio you like, their linked YouTube channel is legit along with their socials, send a message.',
//   },
// ];

// const ForEditors = () => {
//   return (
//     <>
//       <Helmet>
//         <title>Get Paid as a Video Editor | Kre8</title>
//         <meta
//           name="description"
//           content="Join Kre8 as a video editor. Work with YouTubers and Twitch streamers, keep ALL of your earnings, and avoid bidding wars."
//         />
//       </Helmet>

//       <div className="bg-black text-white min-h-screen px-6 py-16">
//         <div className="mx-auto max-w-6xl">
//           <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] items-center mb-12">
//             <div>
//               <p className="inline-flex items-center justify-center rounded-full border border-[#84ff00]/30 bg-[#84ff00]/10 px-4 py-2 text-sm text-[#84ff00] font-semibold mb-6">
//                 Keep ALL revenue. No bidding wars.
//               </p>
//               <h1 className="text-4xl sm:text-5xl font-black tracking-tight mb-6">
//                 Get Paid for Twitch and YouTube Edits — Keep 100% For Every Order.
//               </h1>
//               <p className="text-lg text-gray-300 leading-8 mb-8">
//                 Build a creator-focused editing business with direct client communication, verified briefs, and fair revenue share.
//               </p>
//               <Link
//                 to="/signup"
//                 className="inline-flex m-auto items-center justify-center rounded-full bg-[#84ff00] px-8 py-4 text-base font-semibold text-black shadow-lg shadow-[#84ff00]/20 transition duration-300 hover:bg-white" style={{marginLeft:'30%'}}
//               >
//                 Create Your Editor Profile
//               </Link>
//             </div>
//             <div>
//               <img
//                 src={ss1}
//                 alt="Editor portfolio screenshot"
//                 className="w-full rounded-3xl border border-gray-800 bg-slate-950/80 shadow-2xl shadow-black/30"
//               />
//             </div>
//           </div>

//           <TrustStrip items={trustItems} />

//           <div className="grid gap-10  items-start">
//             <div className="space-y-10">
//               <StepFlow
//                 title="How it works for editors"
//                 note="Tailored steps so you can start taking creator work faster and with more control."
//                 steps={howItWorks}
//               />

//               <div className="rounded-3xl border text-center border-gray-800 bg-slate-950/80 p-8">
//                 <h2 className="text-2xl font-bold mb-3">Why we're BETTER than Fiverr & Upwork</h2>
//                 <div className="space-y-3 text-gray-400">
//                   <p>No visibility games, your profile is shown to creators actively hiring.</p>
//                   <p>No locked pricing, set rates that match YOUR skill.</p>
//                   <p>Direct support for editors, not algorithm-driven exposure.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="space-y-8 text-center">
//               <CredibilityGrid
//                 items={credibilityItems}
//                 note="Proof signals for editors: real creator demand, verified profiles, and fair earnings."
//               />

//               <div className="rounded-3xl border border-gray-800 bg-slate-950/80 p-8">
//                 <h2 className="text-2xl font-bold mb-3">Why We Exist</h2>
//                 <p className="text-gray-400 leading-7">
//                   Built because editors needed a simpler way to find reliable editors without marketplace friction. You guys get anywhere from 15-25% of your cut taken from other sites, that's not right. You deserve rewards for your work and you deserve every single penny.
//                 </p>
//               </div>

//               <div>
//                 <h2 className="text-2xl font-bold mb-6">Common Editor Questions</h2>
//                 <MiniFAQ faqs={faqs} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ForEditors;

import { Link } from "react-router-dom";
import {
  Check,
  X,
  ArrowRight,
  Sparkles,
  UserPlus,
  Search,
  Handshake,
  Users,
  ShieldCheck,
  Scissors,
  ChevronDown,
  ChevronUp,
  type LucideIcon,
} from "lucide-react";
import ss1 from '../images/ss1.webp';
import { useState } from "react";
import SEO, { breadcrumbSchema } from "../Components/SEO";

const NEON = "#84ff00";
const PURPLE = "#9146FF";
const PURPLE_DEEP = "#7a3ae7";
const BG = "#07060d";
const SURFACE = "rgba(255,255,255,0.04)";
const HAIRLINE = "rgba(255,255,255,0.08)";
const GRID_BG =
  "linear-gradient(rgba(255,255,255,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.5) 1px, transparent 1px)";

function ScreenshotSlot({
  label,
  aspect = "16/9",
  accent = "neon",
}: {
  label: string;
  aspect?: string;
  accent?: "neon" | "purple";
}) {
  const color = accent === "purple" ? PURPLE : NEON;
  return (
    <div
      className="relative w-full overflow-hidden rounded-xl border"
      style={{
        aspectRatio: aspect,
        borderColor: HAIRLINE,
        backgroundImage: `url(${ss1})`,
        boxShadow: `0 30px 80px -40px ${color}40`,
      }}
    >
      <img
        aria-hidden
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url(${ss1})`
        }}
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className="rounded-full border px-3 py-1 text-xs uppercase tracking-wider text-zinc-400"
          style={{ borderColor: HAIRLINE, backgroundColor: "rgba(0,0,0,0.3)" }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}

function CTAButton({
  to,
  variant = "primary",
  children,
}: {
  to: string;
  variant?: "primary" | "secondary";
  children: React.ReactNode;
}) {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-all hover:-translate-y-0.5";
  if (variant === "primary") {
    return (
      <Link
        to={to}
        className={`${base} text-black`}
        style={{
          background: NEON,
          boxShadow: `0 10px 40px ${NEON}40`,
        }}
      >
        {children}
        <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
      </Link>
    );
  }
  return (
    <Link
      to={to}
      className={`${base} text-white`}
      style={{
        background: `linear-gradient(135deg, ${PURPLE}, ${PURPLE_DEEP})`,
        boxShadow: `0 10px 40px ${PURPLE}55, inset 0 1px 0 rgba(255,255,255,.15)`,
      }}
    >
      {children}
    </Link>
  );
}

function Section({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={`mx-auto w-full max-w-7xl px-5 sm:px-8 py-20 sm:py-28 ${className}`}>
      {children}
    </section>
  );
}

function TrustBullet({ children }: { children: React.ReactNode }) {
  return (
    <li className="flex items-center gap-2 text-sm text-zinc-400">
      <Check className="h-4 w-4 shrink-0" style={{ color: NEON }} />
      <span>{children}</span>
    </li>
  );
}

function Card({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`rounded-2xl border border-white/10 backdrop-blur-xl p-6 ${className}`}
      style={{
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
        boxShadow:
          "0 20px 60px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.03)",
      }}
    >
      {children}
    </div>
  );
}

function Step({
  n,
  title,
  description,
  accent = "neon",
  icon: Icon,
}: {
  n: number;
  title: string;
  description: string;
  accent?: "neon" | "purple";
  icon: LucideIcon;
}) {
  const color = accent === "purple" ? PURPLE : NEON;
  return (
    <div
      className="flex flex-col rounded-xl border p-6 transition-colors hover:border-white/15"
      style={{
        backgroundColor: SURFACE,
        borderColor: `${color}33`,
        boxShadow: `0 20px 60px -40px ${color}50`,
      }}
    >
      <div className="flex items-center gap-3">
        <div
          className="flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold"
          style={{ backgroundColor: color, color: "#0a0f0d" }}
        >
          {n}
        </div>
        <span
          className="text-xs font-medium uppercase tracking-wider"
          style={{ color }}
        >
          Step {n}
        </span>
      </div>
      <div
        className="mt-5 flex h-10 w-10 items-center justify-center rounded-lg"
        style={{ backgroundColor: `${color}15` }}
      >
        <Icon className="h-5 w-5" style={{ color }} />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-zinc-100">{title}</h3>
      <p className="mt-2 text-sm text-zinc-400">{description}</p>
    </div>
  );
}

function CompareColumn({
  title,
  items,
  positive,
  highlight,
}: {
  title: string;
  items: string[];
  positive: boolean;
  highlight?: boolean;
}) {
  const Icon = positive ? Check : X;
  return (
    <Card
      className={highlight ? "" : "opacity-80"}
      {...(highlight
        ? {
            style: {
              backgroundColor: SURFACE,
              borderColor: `${NEON}40`,
              boxShadow: `0 0 0 1px ${NEON}20, 0 20px 60px -30px ${NEON}40`,
            },
          }
        : {})}
    >
      <div className="mb-5 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-zinc-100">{title}</h3>
        {highlight && (
          <span
            className="rounded-full px-2.5 py-0.5 text-xs font-semibold"
            style={{ backgroundColor: `${NEON}20`, color: NEON }}
          >
            Kre8
          </span>
        )}
      </div>
      <ul className="space-y-3">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-3 text-sm text-zinc-300">
            <Icon
              className="mt-0.5 h-4 w-4 shrink-0"
              style={{ color: positive ? NEON : "#71717a" }}
            />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}

function CredibilityCard({
  icon: Icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <Card className="group transition-colors hover:border-white/15">
      <div
        className="flex h-10 w-10 items-center justify-center rounded-lg"
        style={{ backgroundColor: "rgba(132,255,0,0.1)" }}
      >
        <Icon className="h-5 w-5" style={{ color: NEON }} />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-zinc-100">{title}</h3>
      <p className="mt-2 text-sm text-zinc-400">{description}</p>
    </Card>
  );
}

function FAQItem({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="rounded-xl border transition-colors hover:border-white/15"
      style={{
        backgroundColor: SURFACE,
        borderColor: open ? `${NEON}33` : HAIRLINE,
        boxShadow: open ? `0 20px 60px -40px ${NEON}30` : "none",
      }}
    >
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between p-6 text-left"
      >
        <span className="text-base font-medium text-zinc-100">{question}</span>
        {open ? (
          <ChevronUp className="h-4 w-4 shrink-0 text-zinc-400" />
        ) : (
          <ChevronDown className="h-4 w-4 shrink-0 text-zinc-400" />
        )}
      </button>
      {open && (
        <div className="px-6 pb-6">
          <p className="text-sm leading-relaxed text-zinc-300">{answer}</p>
        </div>
      )}
    </div>
  );
}

const trustItems = [
  "Work with real creators",
  "Keep ALL of your earnings",
  "Editors and clippers can build a real creator profile",
];

const howItWorks = [
  {
    title: "Create Profile",
    desc: "Set up a creator facing profile that highlights your editing or clipping strengths.",
    icon: UserPlus,
  },
  {
    title: "Get Discovered",
    desc: "Appear in creator searches and get ready for requests that fit your style and category.",
    icon: Search,
  },
  {
    title: "Work With Creators",
    desc: "Accept custom editing work or prepare for campaign opportunities as clipping rolls out.",
    icon: Handshake,
  },
];

const credibilityItems = [
  {
    icon: Users,
    title: "Creator focused demand",
    description: "Build a profile around Twitch streamers, gaming creators, short form clips, and custom edits.",
  },
  {
    icon: ShieldCheck,
    title: "Clear creator profiles",
    description: "Show your best work, the games you understand, and whether you focus on editing, clipping, or both.",
  },
  {
    icon: Scissors,
    title: "Campaign ready clippers",
    description: "Clippers can join early and prepare for Twitch clipping campaigns built around TikTok, Shorts, and Reels.",
  },
];

const faqs = [
  {
    id: 1,
    question: "Can I join as a clipper?",
    answer:
      "Yes. Use the current editor signup flow, then make it clear in your profile that you focus on clipping, short form moments, TikToks, Shorts, and Reels.",
  },
  {
    id: 2,
    question: "Do I need to do long form editing?",
    answer:
      "No. Clippers can focus on stream moments and short form content. You can offer long form editing too, but it is not required for the clipping push.",
  },
  {
    id: 3,
    question: "Are clipping campaigns live yet?",
    answer:
      "Campaigns are rolling out. Joining early gives you a profile and a place to point streamers while Kre8 opens campaign access to more creators.",
  },{
    id: 4,
    question: "Can I still join as a regular editor?",
    answer:
      "Yes. Editors can offer Twitch VOD edits, YouTube gaming videos, highlights, thumbnails, clips, or any mix that fits their style.",
  },{
    id: 5,
    question: "If there's an issue, who do I reach out to?",
    answer:
      "You can reach us directly at support@kre8content.com or message one of our mods on Discord for the quickest reply.",
  },
];

export default function ForEditors() {
  return (
    <>
      <SEO
        title="For Twitch Editors and Clippers | Kre8"
        description="Join Kre8 as a Twitch editor or founding clipper. Build your profile and get ready for creator work and clipping campaigns."
        canonicalPath="/for-editors"
        structuredData={breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "For Editors", path: "/for-editors" },
        ])}
      />
      <main
        className="min-h-screen antialiased"
        style={{ backgroundColor: BG, color: "#e5e7eb" }}
      >
      {/* HERO */}
      <Section className="relative overflow-hidden !pt-24 sm:!pt-28">
        <div
          aria-hidden
          className="absolute inset-0 -z-10 opacity-80"
          style={{
            background: `radial-gradient(60% 50% at 20% 20%, ${PURPLE}33, transparent 60%), radial-gradient(50% 50% at 85% 30%, ${NEON}1a, transparent 60%), radial-gradient(40% 40% at 50% 90%, ${PURPLE_DEEP}33, transparent 60%)`,
          }}
        />
        <div
          aria-hidden
          className="absolute inset-0 -z-10 opacity-[0.06]"
          style={{
            backgroundImage: GRID_BG,
            backgroundSize: "60px 60px",
            maskImage:
              "radial-gradient(ellipse at center, black 30%, transparent 70%)",
          }}
        />
        <div className="relative mx-auto grid max-w-6xl gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div className="text-center lg:text-left">
            <p
              className="inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium"
              style={{
                borderColor: `${NEON}55`,
                color: NEON,
                background: `${NEON}10`,
                boxShadow: `0 0 24px ${NEON}22`,
              }}
            >
              <Sparkles className="h-3.5 w-3.5" />
              Early access for editors and clippers
            </p>
            <h1 className="mt-6 text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl leading-[1.05]">
              <span
                className="bg-clip-text text-transparent"
                style={{
                  backgroundImage: `linear-gradient(120deg, ${NEON}, #ffffff 50%, ${PURPLE})`,
                }}
              >
                Build your profile for Twitch editing and clipping campaigns
              </span>
            </h1>
            <p className="mx-auto mt-6 max-w-xl text-lg text-zinc-400 sm:text-xl lg:mx-0 leading-relaxed">
              Create a profile for custom editing work, short form clips, and
              early access to streamer clipping campaigns.
            </p>
            <ul className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 lg:justify-start">
              {trustItems.map((item) => (
                <TrustBullet key={item}>{item}</TrustBullet>
              ))}
            </ul>
            <div className="mt-10 flex flex-wrap justify-center gap-3 lg:justify-start">
              <CTAButton to="/signup">Create Your Profile</CTAButton>
              <CTAButton to="/for-clippers" variant="secondary">
                Join as a Clipper
              </CTAButton>
            </div>
          </div>
          <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
            <ScreenshotSlot label="Editor portfolio screenshot" aspect="4/3" accent="neon" />
          </div>
        </div>
      </Section>

      {/* HOW IT WORKS */}
      <Section>
        <div className="mx-auto max-w-2xl text-center">
          <p
            className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium uppercase tracking-wider"
            style={{ borderColor: HAIRLINE, color: NEON }}
          >
            Tailored steps so you can start taking creator work faster and with more control.
          </p>
          <h2 className="mt-5 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            How it works for editors and clippers
          </h2>
        </div>
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {howItWorks.map((step, i) => (
            <Step
              key={step.title}
              n={i + 1}
              accent={i === 1 ? "purple" : "neon"}
              title={step.title}
              description={step.desc}
              icon={step.icon}
            />
          ))}
        </div>
      </Section>

      {/* COMPARE */}
      <Section>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Why Kre8 is built for creator work
          </h2>
        </div>
        <div className="mt-14 grid gap-5 md:grid-cols-2">
          <CompareColumn
            title="Kre8"
            positive
            highlight
            items={[
              "No visibility games, your profile is shown to creators actively hiring.",
              "No locked pricing, set rates that match YOUR skill.",
              "Clippers can get early access before campaigns fully open.",
            ]}
          />
          <CompareColumn
            title="Fiverr & Upwork"
            positive={false}
            items={[
              "Bidding wars that drive rates down",
              "Algorithm driven visibility you can't control",
              "Platform fees eating your earnings",
              "Generic marketplace, not Twitch or gaming focused",
            ]}
          />
        </div>
        <div className="mt-12 text-center">
          <CTAButton to="/signup">Create Your Profile</CTAButton>
        </div>
      </Section>

      {/* CREDIBILITY GRID */}
      <Section>
        <div className="mx-auto max-w-2xl text-center">
          <p
            className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium uppercase tracking-wider"
            style={{ borderColor: HAIRLINE, color: NEON }}
          >
            Proof signals for editors
          </p>
          <h2 className="mt-5 text-4xl font-bold tracking-tight text-white sm:text-5xl">
              Creator demand, clear profiles, and early campaign access
          </h2>
        </div>
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {credibilityItems.map((item) => (
            <CredibilityCard
              key={item.title}
              icon={item.icon}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </Section>

      {/* WHY WE EXIST */}
      <Section>
        <div className="mx-auto max-w-3xl text-center">
          <div
            className="rounded-2xl border p-8 sm:p-12"
            style={{
              backgroundColor: SURFACE,
              borderColor: `${NEON}30`,
              boxShadow: `0 20px 60px -40px ${NEON}40`,
            }}
          >
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Why We Exist
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-zinc-300">
              Built because editors and clippers need a cleaner way to get in
              front of creators without fighting through generic marketplace
              noise. Kre8 is focused on Twitch content, short form growth, and
              creator relationships that can keep going.
            </p>
            <div className="mt-8 flex justify-center">
              <CTAButton to="/signup">Join Kre8</CTAButton>
            </div>
          </div>
        </div>
      </Section>

      <Section>
        <div className="mx-auto max-w-2xl text-center">
          <p
            className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium uppercase tracking-wider"
            style={{ borderColor: HAIRLINE, color: PURPLE }}
          >
            Questions
          </p>
          <h2 className="mt-5 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Common Questions
          </h2>
        </div>
        <div className="mx-auto mt-14 flex max-w-3xl flex-col gap-4">
          {faqs.map((faq) => (
            <FAQItem key={faq.id} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </Section>

      <Section className="relative overflow-hidden">
        <div
          aria-hidden
          className="pointer-events-none absolute left-1/3 top-1/2 -z-0 h-[400px] w-[500px] -translate-y-1/2 rounded-full opacity-20 blur-3xl"
          style={{ background: `radial-gradient(circle, ${NEON}, transparent 60%)` }}
        />
        <div
          aria-hidden
          className="pointer-events-none absolute right-1/3 top-1/2 -z-0 h-[400px] w-[500px] -translate-y-1/2 rounded-full opacity-20 blur-3xl"
          style={{ background: `radial-gradient(circle, ${PURPLE}, transparent 60%)` }}
        />
        <div className="relative mx-auto max-w-3xl text-center">
          <h2 className="text-5xl font-bold tracking-tight text-white sm:text-6xl">
            Start building your creator profile
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg text-zinc-400">
            Join as an editor or founding clipper and get ready for Twitch
            creator work as the network grows.
          </p>
          <div className="mt-10 flex justify-center">
            <CTAButton to="/signup">Create Your Profile</CTAButton>
          </div>
          <p className="mt-6 text-sm text-zinc-500">
            Clippers can join early before campaigns fully open.
          </p>
        </div>
      </Section>
      </main>
    </>
  );
}
